/**
 * Copy for the "Currently reading" and "Finished" share images (EN / SK / CS).
 * Counted keys carry the forms chosen explicitly by `bookSharePluralForm`.
 */
export const bookShareCopy = {
  en: {
    share: 'Share as an image',
    progressImage: 'Share progress as an image',
    link: 'Share as a link',
    saveFirst: {
      title: 'Save progress and share?',
      body: 'The image will show page {{page}}.',
      finishBody:
        'The book will be marked as finished. You can share the Finished image on the next screen.',
      confirm: 'Save and share',
      cancel: 'Cancel',
    },
    shareBook: 'Share {{title}} as an image',
    preparing: 'Preparing the image…',
    shareUnavailable: 'Sharing isn’t available on this device.',
    shareFailed: 'The image couldn’t be shared. Try again.',
    shareNeedsBuild: 'Sharing needs a new development build.',
    reading: {
      eyebrow: 'Currently reading',
      page: 'Page {{page}} of {{total}}',
      pageOnly: 'Page {{page}}',
      footer: 'Reading in Belore',
    },
    finished: {
      eyebrow: 'Finished',
      footer: 'Finished in Belore',
      pages_one: '{{count}} page',
      pages_few: '{{count}} pages',
      pages_many: '{{count}} pages',
      pages_other: '{{count}} pages',
      days_one: 'in {{count}} day',
      days_few: 'in {{count}} days',
      days_many: 'in {{count}} days',
      days_other: 'in {{count}} days',
      yearBook: 'book {{count}} of {{year}}',
    },
  },
  sk: {
    share: 'Zdieľať ako obrázok',
    progressImage: 'Zdieľať progres ako obrázok',
    link: 'Zdieľať ako odkaz',
    saveFirst: {
      title: 'Uložiť progres a zdieľať?',
      body: 'Na obrázku bude strana {{page}}.',
      finishBody:
        'Kniha sa označí ako dočítaná. Obrázok Dočítané môžeš zdieľať na ďalšej obrazovke.',
      confirm: 'Uložiť a zdieľať',
      cancel: 'Zrušiť',
    },
    shareBook: 'Zdieľať {{title}} ako obrázok',
    preparing: 'Pripravujem obrázok…',
    shareUnavailable: 'Zdieľanie nie je na tomto zariadení dostupné.',
    shareFailed: 'Obrázok sa nepodarilo zdieľať. Skús to znova.',
    shareNeedsBuild: 'Zdieľanie potrebuje nový vývojový build.',
    reading: {
      eyebrow: 'Práve čítam',
      page: 'Strana {{page}} z {{total}}',
      pageOnly: 'Strana {{page}}',
      footer: 'Čítam v Belore',
    },
    finished: {
      eyebrow: 'Dočítané',
      footer: 'Dočítané v Belore',
      pages_one: '{{count}} strana',
      pages_few: '{{count}} strany',
      pages_many: '{{count}} strany',
      pages_other: '{{count}} strán',
      days_one: 'za {{count}} deň',
      days_few: 'za {{count}} dni',
      days_many: 'za {{count}} dňa',
      days_other: 'za {{count}} dní',
      yearBook: '{{count}}. kniha v roku {{year}}',
    },
  },
  cs: {
    share: 'Sdílet jako obrázek',
    progressImage: 'Sdílet pokrok jako obrázek',
    link: 'Sdílet jako odkaz',
    saveFirst: {
      title: 'Uložit pokrok a sdílet?',
      body: 'Na obrázku bude strana {{page}}.',
      finishBody: 'Kniha se označí jako dočtená. Obrázek Dočteno můžeš sdílet na další obrazovce.',
      confirm: 'Uložit a sdílet',
      cancel: 'Zrušit',
    },
    shareBook: 'Sdílet {{title}} jako obrázek',
    preparing: 'Připravuji obrázek…',
    shareUnavailable: 'Sdílení není na tomto zařízení dostupné.',
    shareFailed: 'Obrázek se nepodařilo sdílet. Zkus to znovu.',
    shareNeedsBuild: 'Sdílení potřebuje nový vývojový build.',
    reading: {
      eyebrow: 'Právě čtu',
      page: 'Strana {{page}} z {{total}}',
      pageOnly: 'Strana {{page}}',
      footer: 'Čtu v Belore',
    },
    finished: {
      eyebrow: 'Dočteno',
      footer: 'Dočteno v Belore',
      pages_one: '{{count}} strana',
      pages_few: '{{count}} strany',
      pages_many: '{{count}} strany',
      pages_other: '{{count}} stran',
      days_one: 'za {{count}} den',
      days_few: 'za {{count}} dny',
      days_many: 'za {{count}} dne',
      days_other: 'za {{count}} dní',
      yearBook: '{{count}}. kniha v roce {{year}}',
    },
  },
} as const;
